import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { browserHistory } from "react-router";
import { ActionInterface } from "../../Interface/ActionInterface";
import { PersonInterface } from "../../Entity/Entities/Person/PersonInterface";
import { UserSettingsInterface } from "../../Entity/Entities/Settings/User/UserSettingsInterface";
import Auth from "../../Auth/Auth";
// import Version from "../../Version/Version";
// import Environment from "../../Environment/Environment";
import PersonFactory from "../../Entity/Factories/PersonFactory";
import UserSettingsFactory from "../../Entity/Factories/UserSettingsFactory";
import UserActions from "../../Action/Actions/UserActions";

export default function* checkEmail(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_CHECK_EMAIL_REQUEST
    });

    const res = yield call(Auth.checkEmail, action.payload?.email);

    const user: PersonInterface = PersonFactory.create(res.users[0]);
    const settings: UserSettingsInterface = UserSettingsFactory.create(res.users[0].userSettings[0]);
    const agencies = res.agencies;
    const users = res.users;

    yield put(UserActions.auth(user, settings));

    yield put({
      type: Constants.PAGE_CHECK_EMAIL_SUCCESS,
      payload: {
        user: user,
        users: users,
        agencies: agencies
      }
    });

    browserHistory.push("/auth/confirm");

  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_CHECK_EMAIL_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchCheckEmail() {
  yield takeEvery(Constants.PAGE_CHECK_EMAIL_START, checkEmail);
}
